import { Helmet } from 'react-helmet-async';
import settings from "../../constants/settings";

const Meta = ({
                title,
                description,
                canonical = settings.domain,
                robots = 'index,follow',
                author = 'Mesoft',
                keywords,
                ogTitle,
                ogDescription,
                ogImage,
                ogUrl,
                twitterCard = 'summary_large_image',
                twitterSite,
                googleSiteVerification,
              }) => (
  <Helmet>
    {/* Basic Meta */}
    {title && <title>{title}</title>}
    {description && <meta name="description" content={description} />}
    {keywords && <meta name="keywords" content={keywords} />}
    <meta name="robots" content={robots} />
    <meta name="author" content={author} />
    {/*{canonical && <link rel="canonical" href={canonical} />}*/}
    <link rel="canonical" href={canonical} />
    {googleSiteVerification && <meta name="google-site-verification" content={googleSiteVerification} />}

    {/* Open Graph Tags */}
    {ogTitle && <meta property="og:title" content={ogTitle} />}
    {ogDescription && <meta property="og:description" content={ogDescription} />}
    {ogImage && <meta property="og:image" content={ogImage} />}
    {ogUrl && <meta property="og:url" content={ogUrl} />}
    <meta property="og:type" content="website" />

    {/* Twitter Card Tags */}
    {twitterCard && <meta name="twitter:card" content={twitterCard} />}
    {twitterSite && <meta name="twitter:site" content={twitterSite} />}
  </Helmet>
);

export default Meta;
